import { ApiError } from "./errors";
import type {
  FullAuthResponse,
  FullCatalog,
  FullJoin,
  FullLoadout,
  FullMe,
  FullRankedStatus,
} from "./types";
import type { AuthResponse, Catalog, JoinResponse, Me, RankedStatus } from "../proto/gunrun/v1/api_pb";
import type { Loadout } from "../proto/gunrun/v1/common_pb";

// The server always fills the message-typed fields below; the generated code just cannot say so.
// These functions check that once per response and narrow the type (no copying). A violation is a
// server bug and surfaces as an ApiError "bad_response" (the boot screen shows it with Retry).

function missing(what: string): never {
  throw new ApiError(0, "bad_response", `The server response is missing ${what}`);
}

export function completeLoadout(l: Loadout): FullLoadout {
  if (!l.primary || !l.secondary) missing("a loadout weapon");
  return l as FullLoadout;
}

export function completeMe(me: Me): FullMe {
  if (!me.user) missing("the user");
  if (!me.profile) missing("the profile");
  if (!me.unlocks) missing("the unlocks");
  for (const l of me.loadouts) completeLoadout(l);
  return me as FullMe;
}

export function completeAuth(res: AuthResponse): FullAuthResponse {
  if (!res.me) missing("the account");
  completeMe(res.me);
  return res as FullAuthResponse;
}

export function completeCatalog(catalog: Catalog): FullCatalog {
  if (!catalog.progression) missing("the progression tables");
  for (const w of catalog.weapons) if (!w.bars) missing(`stat bars of ${w.id}`);
  for (const m of catalog.modes) if (!m.rules) missing(`rules of mode ${m.name}`);
  return catalog as FullCatalog;
}

export function completeJoin(join: JoinResponse): FullJoin {
  if (!join.room) missing("the room");
  return join as FullJoin;
}

export function completeRankedStatus(status: RankedStatus): FullRankedStatus {
  if (status.match) completeJoin(status.match);
  return status as FullRankedStatus;
}
